import { useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import Select from "react-select";
import { useNavigate } from "react-router-dom";

import { useApplicationOrdersPaginate } from "@/hooks/planning/application-order/applicationOrders";

import classes from "./orderApplicationFilter.module.scss";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

const AppOrdersFilter = ({ filters, applyFilter }) => {
	const navigate = useNavigate();

	const { customer } = useSelector((state) => state.auth.user);

	const { data } = useApplicationOrdersPaginate(filters);
	const { business, states, types } = data;

	const [appOrderFilter, setAppOrderFilter] = useState(filters && filters.appOrderFilter);
	const [businessFilter, setBusinessFilter] = useState(filters && filters.businessFilter);
	const [appOrdersStateFilter, setAppOrdersStateFilter] = useState(filters && filters.appOrdersStateFilter);
	const [internalCodeFilter, setInternalCodeFilter] = useState(filters && filters.internalCodeFilter);
	const [typeFilter, setTypeFilter] = useState(
		filters && filters.typeFilter ? (Array.isArray(filters.typeFilter) ? filters.typeFilter : filters.typeFilter.split(",").map(Number)) : [],
	);

	const [dateFilter, setDateFilter] = useState(filters && filters.dateFilter);
	const [dateToFilter, setDateToFilter] = useState(filters && filters.dateToFilter);

	const handleCleanFilter = () => {
		navigate(window.location.pathname, { replace: true });
		setTypeFilter([]);
		applyFilter({
			businessFilter: "",
			appOrderFilter: "",
			dateFilter: "",
			dateToFilter: "",
			appOrdersStateFilter: "",
			internalCodeFilter: "",
			typeFilter: "",
		});
	};

	const handleApplyFilter = () => {
		applyFilter({
			businessFilter,
			appOrderFilter,
			dateFilter,
			dateToFilter,
			appOrdersStateFilter,
			internalCodeFilter,
			typeFilter: typeFilter.join(","),
		});
	};

	return (
		<Col md={2} className={classes.filter}>
			<div className={classes.filterTitle}>
				<h4 className={classes.titleH4}>Filtros</h4>
				<hr className={classes.filterHr} />
			</div>

			<div className={classes.divContent}>
				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Razón Social</span>
					</Col>
					<Col md={12}>
						<Select
							value={business && business.filter((b) => Number(b.value) === Number(businessFilter))[0]}
							placeholder={<div>Seleccione</div>}
							options={business}
							onChange={(value) => setBusinessFilter(value.value)}
							components={{ NoOptionsMessage }}
						/>
					</Col>
				</Row>

				<hr />

				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Estado Órden de Aplicación</span>
					</Col>
					<Col md={12}>
						<Select
							value={states && states.filter((b) => Number(b.value) === Number(appOrdersStateFilter))[0]}
							placeholder={<div>Seleccione</div>}
							options={states}
							onChange={(value) => setAppOrdersStateFilter(value.value)}
							components={{ NoOptionsMessage }}
						/>
					</Col>
				</Row>

				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Tipo de Orden</span>
					</Col>
					<Col md={12}>
						<Select
							value={types && types.filter((b) => typeFilter.includes(Number(b.value)))}
							placeholder={<div>Seleccione</div>}
							options={types}
							onChange={(selected) => setTypeFilter(selected?.map((s) => Number(s.value)) || [])}
							components={{ NoOptionsMessage }}
							isMulti={true}
							isClearable={false}
						/>
					</Col>
				</Row>

				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>N° Órden de Aplicación</span>
					</Col>
					<Col md={12}>
						<Form.Control
							type="text"
							name="app_order_code"
							placeholder=" "
							value={appOrderFilter ? appOrderFilter : ""}
							onChange={(e) => setAppOrderFilter(e.target.value)}
						/>
					</Col>
				</Row>

				{!!customer.use_code_oa && (
					<Row className={classes.divForm}>
						<Col md={12} className={classes.divLabel}>
							<span className={classes.label}>Cód. Interno</span>
						</Col>
						<Col md={12}>
							<Form.Control
								type="text"
								name="internal_code"
								placeholder=" "
								value={internalCodeFilter ? internalCodeFilter : ""}
								onChange={(e) => setInternalCodeFilter(e.target.value)}
							/>
						</Col>
					</Row>
				)}

				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Fecha Ingreso</span>
					</Col>
					<Col md={12}>
						<small>Desde</small>
						<Form.Control
							type="text"
							name="created_at"
							placeholder=" "
							value={dateFilter}
							onChange={(e) => setDateFilter(e.target.value)}
							onFocus={(e) => (e.target.type = "date")}
						/>
					</Col>
					<Col md={12}>
						<small>Hasta</small>
						<Form.Control
							type="text"
							name="created_at"
							placeholder=" "
							value={dateToFilter}
							onChange={(e) => setDateToFilter(e.target.value)}
							onFocus={(e) => (e.target.type = "date")}
						/>
					</Col>
				</Row>
			</div>

			<div className={classes.divFooter}>
				<Button className={classes.buttonClean} onClick={() => handleCleanFilter()}>
					Limpiar
				</Button>

				<Button className={classes.buttonApply} onClick={() => handleApplyFilter()}>
					Aplicar
				</Button>
			</div>
		</Col>
	);
};

export default AppOrdersFilter;
